"use client";

import { useState } from "react";

import { Button } from "@/components/buttons/Button";
import { renewStripeSubscriptionAction } from "@/data/payment/actions/renewStripeSubscriptionAction";
import { logError } from "@/utils/logError";

export function RenewSubscriptionButton() {
  const [isLoading, setIsLoading] = useState(false);

  const handleRenewSubscription = async () => {
    try {
      setIsLoading(true);
      await renewStripeSubscriptionAction();
    } catch (error) {
      console.error("Could not renew subscription", error);
      logError("Could not renew subscription");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button onClick={handleRenewSubscription} loading={isLoading}>
      Renew subscription
    </Button>
  );
}
